export default "__VITE_ASSET__a61f07ff__"